import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const fetchSEOData = async (pagePath) => {
  try {
    const formattedPath = pagePath.startsWith('/') ? pagePath : `/${pagePath}`;
    const response = await axios.get(`${API_BASE_URL}/api/seo${formattedPath}`);
    
    if (response.data) {
      return {
        seo: response.data.seo || {},
        content: response.data.content || null
      };
    }
    return getDefaultSEO();
  } catch (error) {
    console.error('Error fetching SEO data:', error);
    return getDefaultSEO();
  }
};

const getDefaultSEO = () => ({
  seo: {
    title: 'Restaurant Name',
    description: 'Welcome to our restaurant',
    keywords: 'restaurant, dining, food',
    og_title: 'Restaurant Name',
    og_description: 'Best dining experience',
    og_image: '/images/default-og.jpg',
    canonical_url: window.location.href,
    robots: 'index, follow'
  },
  content: null
});